module.exports = __webpack_public_path__ + "img/xm06-c9cf46.jpg";